// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ReconciliationImportHistoryController = function ($scope, $location, ReconciliationImport, ReconciliationImportHistoryService, BlEbicsAvailabilityService, gettextCatalog, gettext) {
   
    $scope.paginationIsOn = true;
    $scope.isFirstOpen = true;
    $scope.openedItems = [];
    $scope.importLog = [];
    $scope.lastAutoDownloadTimestamp = ReconciliationImport.getLastAutoDownloadTimestamp({}, function (response) { $scope.lastAutoDownloadTimestamp = response.data; });

    $scope.requiredToUpdate = true;
    
    var getLog = function () {

        $scope.importLogPaginator = $scope.paginator(function (options, callback) {
            return ReconciliationImport.query(options, function (data)  {
                if(!$scope.openedItems) {
                    $scope.openedItems = [];
                }

                callback();
                $scope.importLog = data;
                ReconciliationImportHistoryService.processPreviouslyOpenedElements($scope.importLog, $scope.openedItems);

                if(ReconciliationImportHistoryService.areAllItemsInTerminalPhase(data)) {
                    $scope.requiredToUpdate = false;
                }
            });
        }, {}, 20);
    };

    getLog();

    var source = Rx.Observable
    .interval(10000)
    .timeInterval();

    var subscription = source.subscribe(
    function (x) {
        if(!$scope.requiredToUpdate){
            return;
        }
        
        getLog();
    });


    $scope.ReconciliationImportMode = ReconciliationImportHistoryService.RECONCILIATION_IMPORT_MODE;

    $scope.toggleImportInfoVisibility = function(importItem, index) {
        ReconciliationImportHistoryService.toggleOpenedItem($scope.openedItems,importItem.Id);

        if(index == 0 &&  $scope.isFirstOpen)
        {
            $scope.isFirstOpen = false;
        }
        else
		{
			ReconciliationImportHistoryService.toggleImportInfoVisibility(importItem);
		}
    };

    $scope.setHistoryItemHeader = function(importItem)
    {
        return ReconciliationImportHistoryService.setHistoryItemHeader(importItem);
    }

    $scope.IsListEmpty = function(list)
    {
        return ReconciliationImportHistoryService.IsListEmpty(list);
    }

    $scope.getProcessingStatusClass = function(statusValue)
    {
       return ReconciliationImportHistoryService.getProcessingStatusClass(statusValue);
    }

    $scope.$on("$destroy", function handler() {
        subscription.dispose();
    });

    $scope.back = function() {
        $location.path("/activities/reconciliation");
    };

    $scope.showSpecificError = function(errorMessage) {

        ReconciliationImportHistoryService.showSpecificError(errorMessage);
    };

    $scope.getStatusFileColumnMessage = function(item) {

        return ReconciliationImportHistoryService.getStatusFileColumnMessage(item);
    }

    $scope.getActorName = function(item) {

        return (item && item.DownloadFromBankMode === "Automatic") 
            ? gettextCatalog.getString(gettext("Automated process"))
            : item.UserName;
    }

    BlEbicsAvailabilityService.requestEbicsAvailableFlag();
    
    $scope.isEbicsAvailable = function () {
        return BlEbicsAvailabilityService.isEbicsAvailable();
    };

    $scope.isEbicsDownloadReconciliationAutomatically = function () {
        return BlEbicsAvailabilityService.isEbicsDownloadReconciliationAutomatically();
    };
};

ReconciliationImportHistoryController.$inject = ['$scope', '$location', 'ReconciliationImport', 'ReconciliationImportHistoryService', 'BlEbicsAvailabilityService', 'gettextCatalog', 'gettext'];
